/** User-facing name for the global assistant (popover, workflows, assignees, etc.). */
export const VALIDERE_ASSISTANT_DISPLAY_NAME = "Validere Assistant";
